var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CollydeLogo from '__assets/images/logo.png';
import './HeaderAuth.scss';
var HeaderAuth = function (_a) {
    var logo = _a.logo, color = _a.color;
    return (_jsx("div", __assign({ className: "component__header-auth" }, { children: logo ? (_jsx("div", { className: "party-logo", style: { backgroundImage: "url(" + logo + ")", backgroundColor: color } }, void 0)) : (_jsx("img", { alt: "Collyde", src: CollydeLogo }, void 0)) }), void 0));
};
export default HeaderAuth;
